import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import DoneIcon from '@mui/icons-material/Done';
import { Button, Stack } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme: Theme) => ({
    btnSave: {},
}));

interface Props {
    onSave: () => void;
    onCancel: () => void;
    onDelete?: () => void;
    allowDelete?: boolean;
    size?: 'small' | 'medium';
}

export default function EditButtonGroup({
    onSave,
    onCancel,
    onDelete,
    allowDelete = true,
    size = 'medium',
}: Props) {
    const { classes } = useStyles();
    return (
        <Stack direction="row" spacing={1}>
            <Button
                aria-label="Save"
                size={size}
                onClick={onSave}
                color="success"
                variant="outlined"
                startIcon={<DoneIcon />}
            >
                Save
            </Button>
            {allowDelete && (
                <Button
                    aria-label="Delete"
                    size={size}
                    onClick={onDelete}
                    startIcon={<DeleteIcon />}
                >
                    Delete
                </Button>
            )}
            <Button
                aria-label="Cancel"
                size={size}
                onClick={onCancel}
                variant="outlined"
                startIcon={<CloseIcon />}
            >
                Cancel
            </Button>
        </Stack>
    );
}
